import React from 'react'

import Loader from 'components/LayoutComponents/Loader'

import SecondaryMenu from '../SecondaryMenu'
import useSustainabilityMenu from './menu'

const SettingsMenu = ({ setSelectedKeys, baseUrl }) => {
  const [items, { loading }] = useSustainabilityMenu(baseUrl)

  if (loading) {
    return <Loader />
  }

  return (
    <SecondaryMenu
      title="sustainability.menu"
      items={items}
      setSelectedKeys={setSelectedKeys}
      localisedLabels
    />
  )
}

export default SettingsMenu
